export function downloadCsv(filename, rows) {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (!safeRows.length) return;

  const headers = Array.from(
    safeRows.reduce((set, row) => {
      Object.keys(row || {}).forEach((k) => set.add(k));
      return set;
    }, new Set())
  );

  const esc = (v) => {
    const raw = v == null ? "" : String(v);
    const escaped = raw.replace(/"/g, "\"\"");
    return `"${escaped}"`;
  };

  const lines = [
    headers.map(esc).join(","),
    ...safeRows.map((row) => headers.map((h) => esc(row?.[h])).join(",")),
  ];

  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "export.csv";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
